"use client";

import { useSyncExternalStore } from "react";

// =============================================================================

// A hovering pointer and room for the floating card next to the titles
const QUERY = "(hover: hover) and (pointer: fine) and (min-width: 48rem)";

function subscribe(onChange: () => void) {
  const media = window.matchMedia(QUERY);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
}

/**
 * Whether the hover layout (floating card) fits: a mouse or trackpad and a
 * wide enough viewport. False on the server and during hydration, so that
 * the accordion markup renders first.
 */
export function useCanHover(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false
  );
}

// =============================================================================
